var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layouts-content-view" },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "layouts-content-view__state" },
            [_c("b-spinner")],
            1
          )
        : _vm.items.length === 0
        ? _c("div", { staticClass: "layouts-content-view__state" }, [
            _vm._v("\n    No layouts found.\n  "),
          ])
        : _c("ItemGrid", {
            attrs: {
              items: _vm.gridItems,
              columns: _vm.GRID_COLUMNS,
              "columns-md": _vm.GRID_COLUMNS_MD,
            },
            on: {
              "item-click": function ($event) {
                return _vm.showLayoutPreviewModal($event.id)
              },
            },
          }),
      _vm._v(" "),
      _vm.lastPage > 1
        ? _c("ItemPagination", {
            attrs: {
              "total-rows": _vm.lastPage * _vm.pageSize,
              "per-page": _vm.pageSize,
            },
            on: { change: _vm.fetchLayouts },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("LayoutPreviewModal", {
        ref: "layoutPreviewModal",
        on: { "add-layers": _vm.onAddLayers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }